import {ChangeDetectionStrategy, Component, computed, inject, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {rxResource, toSignal} from '@angular/core/rxjs-interop';
import {AssetComponent} from '../asset.component';
import {ClientAssetService} from 'src/app/services/AIReports/client-asset-service';
import {ChatStore} from 'src/app/services/store';
import {TranslateModule, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-asset-list',
  standalone: true,
  imports: [CommonModule, AssetComponent, TranslateModule],
  templateUrl: './asset-list.component.html',
  styleUrl: './asset-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetListComponent {
  private readonly chatStore = inject(ChatStore);
  private readonly assetService = inject(ClientAssetService);
  private readonly translate = inject(TranslateService);
  private readonly _langChange = toSignal(this.translate.onLangChange, { initialValue: null });

  readonly assetsResource = rxResource({
    params: () => this.chatStore.thread_id(),
    stream: ({params: threadId}) => this.assetService.listAll(threadId),
  });

  readonly assetTypeLabels = computed(() => {
    this._langChange();
    return new Map(
      (this.assetsResource.value() ?? []).map(a => {
        const key = `assetType.${a.type}`;
        const translated = this.translate.instant(key);
        return [a.id, translated !== key ? translated : a.type] as [string, string];
      })
    );
  });

  protected readonly expandedAssets = signal<Set<string>>(new Set());
  protected readonly expandedMeta = signal<Set<string>>(new Set());

  toggleAsset(id: string): void {
    this.expandedAssets.update(set => {
      const next = new Set(set);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  }

  toggleMeta(id: string): void {
    this.expandedMeta.update(set => {
      const next = new Set(set);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  }
}
